<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect opacity="0.5" x="4" y="4" width="10" height="10" rx="2" stroke="#9FABBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<rect x="7" y="7" width="10" height="10" rx="2" fill="white" stroke="#9FABBE" stroke-width="1.5"/>
</svg>
